import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, ReviewsStepData } from '@packages/shared/core/quiz/entities';

type ReviewsQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const ReviewsQuizStep = ({ id, renderQuizScreen }: ReviewsQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData, userPreferences } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const onContinue = async () => next();

  const goBack = async () => back();

  return (
    <>
      {renderQuizScreen({
        onContinue,
        goBack,
        goal: userPreferences.goal,
        ...(stepData as ReviewsStepData),
      })}
    </>
  );
};

export default ReviewsQuizStep;
